export const MOSAIC_VERSION = '1.355.1'
